import { Traveller, TravelDetails, PersonalDetails } from "../../types/travel/Policy";

export const getSpouseFromTravellers = (isTravellerTypeGroup: boolean, noOfTravellers: number, index: number) =>
  !isTravellerTypeGroup && noOfTravellers > 1 && index > 0;

export const updateTravellersOnAdultCount = (travelDetails: TravelDetails) => {
  const newTravellers = [] as Traveller[];
  const { adultCount } = travelDetails;
  updatedTravellers(adultCount, newTravellers, false);
  return newTravellers;
};

const updatedTravellers = (count: number, newTravellers: Traveller[], isChild: boolean) => {
  for (let i = 0; i < count; i++) {
    newTravellers.push({ fullName: "", identificationNumber: "", dateOfBirth: null, identificationNumberStatus: "unknown", isChild });
  }
};
export const updateTravellersOnChildCount = (travelDetails: TravelDetails) => {
  const newTravellers = [] as Traveller[];
  const { childrenCount } = travelDetails;
  if (checkIfGroupOrIndividual(travelDetails)) {
    updatedTravellers(childrenCount, newTravellers, true);
  }
  return newTravellers;
};

const travellerIsRequester = (personalDetails: PersonalDetails, currentTravellers: Traveller[]) => {
  currentTravellers[0].fullName = personalDetails.requester.fullName;
  currentTravellers[0].identificationNumber = personalDetails.requester.identificationNumber;
  currentTravellers[0].dateOfBirth = personalDetails.requester.dateOfBirth;
  currentTravellers[0].identificationNumberStatus = personalDetails.requester.identificationNumberStatus;
  return [...currentTravellers];
};

export const updateTravellersIsRequesterChange = (
  personalDetails: PersonalDetails,
  requestingPersonIsTravellingPerson: boolean,
  currentTravellers: Traveller[]
) => {
  let newTravellers: Traveller[];
  if (requestingPersonIsTravellingPerson) {
    newTravellers = travellerIsRequester(personalDetails, currentTravellers);
  } else {
    currentTravellers[0].fullName = "";
    currentTravellers[0].identificationNumber = "";
    currentTravellers[0].dateOfBirth = null;
    currentTravellers[0].identificationNumberStatus = "unknown";
    newTravellers = [...currentTravellers];
  }
  return newTravellers;
};
export const updateTravellersOnRequesterChange = (
  personalDetails: PersonalDetails,
  requestingPersonIsTravellingPerson: boolean,
  currentTravellers: Traveller[]
) => {
  let newTravellers: Traveller[];
  if (requestingPersonIsTravellingPerson) {
    newTravellers = travellerIsRequester(personalDetails, currentTravellers);
  } else {
    newTravellers = [...currentTravellers];
  }
  return newTravellers;
};

export const updateTravellersType = (groupType: TravelDetails["groupType"], adultCount: number, childCount: number) =>
  groupType !== "family" && adultCount + childCount > 1 ? "group" : groupType;

const checkIfGroupOrIndividual = (travelDetails: TravelDetails) => {
  const { groupType, adultCount, childrenCount, policyType } = travelDetails;
  return groupType !== "family" && adultCount + childrenCount > 0 && policyType === "single-trip";
};
